import getAppFromLinkPathname from './getAppFromLinkPathname';

export default function currentApplication() {
  return getAppFromLinkPathname(window.location.pathname);
}
